import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { CreateScreen } from "./create";
import { EditScreen } from "./edit";

const localRecommendationTypes: ResourceProps = {
  name: Resource.LOCAL_RECOMMENDATION_TYPES,
  icon: Icon,
  list: ListScreen,
  create: CreateScreen,
  edit: EditScreen,
  options: {
    label: "Local Rec. Types",
  },
};

export default localRecommendationTypes;
